multiplelocationSelector
<template>
  <v-container class="pa-0 ma-0" v-if="organizationStructure">
    <v-row class="pa-0 ma-0">
      <v-col cols="12" sm="12" :md="mdCols" class="pa-0 ma-0">
        <MultipleSelect
          data-private
          required
          itemValue="id"
          :class="verticalLayout ? '' : 'me-3'"
          :label="$t('common.site_other')"
          :options="siteOptions"
          :value="location.sites"
          :cacheItems="false"
          @change="onChangeSites"
        />
      </v-col>

      <v-col cols="12" sm="12" :md="mdCols" class="pa-0 ma-0">
        <MultipleSelect
          data-private
          itemValue="id"
          :label="$t('common.tag_other')"
          :options="tagsOptions"
          :value="location.tags"
          @change="onChangeTags"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MultipleSelect from '../Core/MultipleSelect.vue'
import { mapGetters } from 'vuex'
import mixin from '@/mixins/mixin.vue'
import _ from 'lodash'

export default {
  name: 'MultipleLocationSelector',

  mixins: [mixin],

  components: {
    MultipleSelect,
  },

  props: {
    location: {
      type: Object,
      required: false,
      default() {
        return {
          sites: [],
          tags: [],
        }
      },
    },
    verticalLayout: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      tags: [],
      loading: false,
    }
  },

  computed: {
    ...mapGetters([
      'account',
      'organizationStructure',
      'organizationId',
      'organizationSites',
      'organizationTags',
    ]),

    mdCols() {
      return this.verticalLayout ? '12' : '6'
    },

    siteOptions() {
      return this.organizationSites.map(site => {
        return {
          ...site,
          subtitle: this.$t(`countries.${site.countryCodes[0]}`),
          subtitleIcon: 'mdi-earth',
        }
      })
    },

    tagsOptions() {
      const tags = this.organizationTags?.filter?.(tag =>
        this.location?.sites?.some?.(site => {
          if (!tag.sites) return true
          return tag?.sites?.includes(site) || tag?.sites?.length === 0
        })
      )

      return _.sortBy(tags, 'name')
    },
  },

  methods: {
    onChangeSites(sites = []) {
      this.$emit('change', {
        ...this.location,
        sites,
        tags: [],
      })
    },

    onChangeTags(value = []) {
      this.$emit('change', {
        ...this.location,
        tags: value,
      })
    },
  },
}
</script>
